module.exports = {
	"classes": [
		"baa-page",
		"header-dark"
	],
	"title": "Business Associate Agreement (BAA)Editable Subscriptions",
	"metas": {
		"description": "This page provides Auth0's BAA, for use by Auth0 prospects and customers who are 'covered entities' or 'business associates' under HIPAA, and who require Auth0 to process 'protected health care information."
	},
	"opengraph": {
		"og:title": "Business Associate Agreement (BAA)",
		"og:description": "This page provides Auth0's BAA, for use by Auth0 prospects and customers who are 'covered entities' or 'business associates' under HIPAA, and who require Auth0 to process 'protected health care information.",
		"og:url": "https://auth0.com/legal/baseline/baa"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/baa/metadata.json
// module id = 1406
// module chunks = 0